/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_LabelInputs */



/**
* | output |
* | --- |
* | "Delete key" |
*
* @param {Options_Api_Keys_Delete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_label = /** @type {((inputs?: Options_Api_Keys_Delete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entf-Taste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tasto Elimina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить клавишу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tecla de borrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除键")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除キー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजी हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tecla Delete")
	return /** @type {LocalizedString} */ ("Delete key")
});